export default __webpack_public_path__ + "static/media/no-image.a6cd0dd3.png";